import styled from '@emotion/styled';
import { SilkIcon } from 'src/domains/sportsbook/assets/icons/SilkIcon';
import { SilkSecondaryIcon } from 'src/domains/sportsbook/assets/icons/SilkSecondaryIcon';
import { withConfig } from 'src/withConfig';

export const SilkIconWrapperNew = withConfig(theme => styled(SilkIcon, { label: 'SilkIconWrapperNew' })`
    fill: ${theme.star.racingNextOff.raceBox.bgColor};
    width: 40px;
`);

export const SilkIconWrapperSecondary = withConfig(theme => styled(SilkSecondaryIcon, { label: 'SilkIconWrapperSecondary' })`
    fill: ${theme.star.racingNextOff.raceBox.bgColorQuaternary};
    width: 40px;
`);